import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-abmcategorias-filter',
  templateUrl: './abmcategorias-filter.component.html',
  styleUrls: ['./abmcategorias-filter.component.scss']
})
export class ABMCategoriasFilterComponent implements OnInit {

  public showFilters = false;
  
  constructor() { }

  ngOnInit() {
  }

  onApply(e){
    // dont hide the filter window when clicking the apply button
    e.stopPropagation();
  }

  cleanFilters(e) {
    this.onApply(e);
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/abmcategorias-filter/abmcategorias-filter.component.ts